/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminGetSeries } from '../fn/admin-inventory-controller/admin-get-series';
import { AdminGetSeries$Params } from '../fn/admin-inventory-controller/admin-get-series';
import { SeriesWithRelations } from '../models/series-with-relations';

@Injectable({ providedIn: 'root' })
export class AdminInventoryControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `seriesControllerAdminGetSeries()` */
  static readonly SeriesControllerAdminGetSeriesPath = '/admin/inventories/{inventoryId}/series';

  /**
   * Retrieves all series associated with a given inventory ID, including their related entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminGetSeries()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetSeries$Response(params: AdminGetSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SeriesWithRelations>>> {
    return adminGetSeries(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all series associated with a given inventory ID, including their related entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminGetSeries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetSeries(params: AdminGetSeries$Params, context?: HttpContext): Observable<Array<SeriesWithRelations>> {
    return this.adminGetSeries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SeriesWithRelations>>): Array<SeriesWithRelations> => r.body)
    );
  }

}
